<template>
  <van-popup
    :value="value"
    @input="$emit('input', $event)"
    class="voice-select-popper"
    position="bottom"
  >
    <div class="speaker-fixed">
      <p class="choose-speaker-title">{{ `请选择${limitNum}款免费解锁的声音` }}</p>
      <p class="choose-speaker-info">点击头像可查看配音师详情并试听</p>
      <!-- <p>{{ `获得免费解锁 ${limitNum} 款声音权益` }}</p> -->
      <div
        class="search-input-wrapper"
        ref="searchInputWrapper"
        v-show="supportSearch"
      >
        <SearchInput
          v-model="searchInput"
          placeholder="输入发音人名称搜索"
          @search="onSearch"
        />
      </div>
      <!-- 发音人列表 start -->
      <div
        class="speaker-list"
        v-infinite-scroll="loadMore"
        infinite-scroll-distance="30"
        infinite-scroll-delay="300"
        ref="speakerListRef"
      >
        <div
          v-for="(speakerItem, speakerIndex) in speakerList"
          :key="keyOfItem(speakerItem)"
          :class="{
            active: isItemSelected(speakerItem),
          }"
          class="list-item"
        >
          <div
            class="img-box"
            :style="`background-image: url(${speakerItem.imgUrl});`"
            @click="onSpeakerDetail(speakerItem, speakerIndex)"
          ></div>
          <span @click="onSpeakerDetail(speakerItem, speakerIndex)">{{ speakerItem.name }}</span>
          <div class="no-choose active-icon" @click="onSpeakerSelect(speakerItem, speakerIndex)">
            <img
              src="@/assets/images/icon_check.svg"
              alt="确认选择发音人 icon"
            />
          </div>
          <div v-if="!isItemSelected(speakerItem)" class="no-choose" @click="onSpeakerSelect(speakerItem, speakerIndex)">
            <img src="@/assets/images/no_choose.svg" alt="">
          </div>
        </div>
      </div>
      <!-- 发音人列表 end   -->
      <!-- 底部按钮区 -->
      <div ref="listBottomRef" class="speaker-list-bottom">
        <div
          v-if="isTipVisible&&isTipError"
          :class="{ error: isTipError }"
          class="tips-text"
        >
          <span>{{ `请选择 ${limitNum} 款你喜欢的声音` }}</span>
        </div>
        <!-- 提示文字 end   -->
        <!-- 提示已选择的发音人 start -->
        <div v-if="!isTipVisible" class="tips-text">
          <ul>
            <li>已选发音人：</li>
            <li>{{ selectedNameText }}</li>
          </ul>
          <div @click="clearSelectedSpeaker" class="clear-btn">清空</div>
        </div>
        <!-- 提示已选择的发音人 start -->
        <button @click="confirmSpeaker">前往支付</button>
      </div>
      <voiceShop ref="voiceShop" v-show="false"></voiceShop>
    </div>
  </van-popup>
</template>
<script>
import SearchInput from "./search-input.vue";
import infiniteScroll from "@/components/infinite-scroll";
import { judgeDeviceType } from "@/utils/device";
import { toast } from "@/utils/util";
import voiceShop from "../../voiceShop/voiceShop.vue";
import $ from "jquery";

export default {
  directives: { infiniteScroll },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    speakerList: {
      type: Array,
      default: () => [],
    },
    limitNum: {
      type: Number,
      default: 0,
    },
    supportSearch: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    getSpeakerList: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    SearchInput,
    voiceShop
  },
  data() {
    return {
      selectedList: [], // 选中的发音人列表
      isTipVisible: true,
      isTipError: false,
      searchInput: "",
    };
  },
  watch: {
    value: async function () {
      if (!this.value) {
        // 关闭时清空重置弹窗状态
        this.scrollToTop();
        this.isTipVisible = true;
        this.isTipError = false;
        if (this.searchInput) {
          this.searchInput = "";
          await this.searchSpeakerList();
        }
        this.selectedList = [];
      }
    },
  },
  computed: {
    selectedNum() {
      return this.selectedList.length;
    },
    selectedNameText() {
      return this.selectedList.map((item) => item.name).join("，");
    },
  },
  mounted() {
    // 初始化窗口高度
    this.initWinHeight = window.innerHeight;

    //  ios键盘处理，支持ios13以上
    if (judgeDeviceType.isIOS && window.visualViewport) {
      const visualViewport = window.visualViewport;
      this.initWinHeight = visualViewport.height;
      visualViewport.addEventListener("resize", this.onIosKeyboardChange);
    }

    //  安卓键盘处理
    if (judgeDeviceType.isAndroid) {
      window.addEventListener("resize", this.onAndroidKeyboardChange);
    }
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
    if (judgeDeviceType.isIOS && window.visualViewport) {
      const visualViewport = window.visualViewport;
      visualViewport.removeEventListener("resize", this.onIosKeyboardChange);
    }
    window.removeEventListener("resize", this.onAndroidKeyboardChange);
  },
  methods: {
    onAndroidKeyboardChange() {
      const { listBottomRef } = this.$refs;
      if (listBottomRef) {
        // 安卓键盘弹起隐藏底部按钮
        console.log("====>>>>安卓", window.innerHeight, this.initWinHeight);
        listBottomRef.hidden = window.innerHeight < this.initWinHeight;
      }
    },
    onIosKeyboardChange() {
      const { speakerListRef, listBottomRef } = this.$refs;
      if (speakerListRef) {
        console.log("====>>>>ios", visualViewport.height, this.initWinHeight);
        const keybordHeight = this.initWinHeight - visualViewport.height; // 键盘高度
        const bottom =
          keybordHeight > 0 ? keybordHeight - listBottomRef.offsetHeight : 0;
        speakerListRef.style.marginBottom = bottom + "px";
      }
    },
    scrollToTop() {
      const list = this.$refs.speakerListRef;
      if (list) {
        list.scrollTop = 0;
      }
    },
    keyOfItem(item) {
      return `${item.storeId}-${item.speakerId}`;
    },
    isItemSelected(item) {
      const key = this.keyOfItem(item);
      return !!this.selectedList.find((item) => this.keyOfItem(item) === key);
    },
    onSpeakerSelect(item) {
      const currentKey = this.keyOfItem(item);
      const isSelected = this.isItemSelected(item);
      if (!isSelected && this.selectedNum >= this.limitNum) {
        toast(`最多可选择${this.limitNum}款声音`, "top");
        return;
      }

      if (isSelected) {
        this.selectedList = this.selectedList.filter(
          (item) => this.keyOfItem(item) !== currentKey
        );
      } else {
        this.selectedList.push(item);
      }

      this.isTipError = false;
      this.isTipVisible = this.selectedNum === 0;
    },
    getDetailInitData(item){
      return new Promise( resolve => {
        let voiceShop = this.$refs.voiceShop
        voiceShop.keyWord = item.name
        resolve(voiceShop.searchSpeaker(true, true))
      }) 
    },
    async onSpeakerDetail(item){
      let voiceShop = this.$refs.voiceShop
      // voiceShop.keyWord = item.name
      // voiceShop.searchSpeaker(true, true)
      await this.getDetailInitData(item)

      voiceShop.initDetailData(voiceShop.speakerList[0])
      voiceShop.showDetail = true
      $(".voice-container").addClass("voice-container2");
    },
    clearSelectedSpeaker() {
      this.selectedList = [];
      this.isTipError = false;
      this.isTipVisible = true;
    },
    confirmSpeaker() {
      if (this.selectedNum < this.limitNum) {
        this.isTipVisible = true;
        this.isTipError = true;
        return;
      }

      this.$emit("confirm", this.selectedList);
    },

    // 确认输入
    async onSearch() {
      //防抖
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.searchSpeakerList();
      }, 500);
    },
    async searchSpeakerList() {
      clearTimeout(this.searchTimer); //防止输入时瞬间关闭弹窗
      await this.getSpeakerList({
        keyword: this.searchInput,
        currentPage: 0,
      });
      this.$nextTick(() => {
        this.scrollToTop();
      });
    },
    loadMore() {
      this.getSpeakerList({
        keyword: this.searchInput,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.voice-select-popper {
  top: 200px;
  background: none;
  .speaker-fixed {
    position: fixed;
    top: 200px;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 11;
    display: flex;
    flex-direction: column;
    // grid-template-rows: 136px 70px auto 80px 160px;
    border-radius: 30px 30px 0 0;
    background-color: #fff;

    p {
      text-align: center;
      font-size: 32px;
      font-family: HarmonyOS_Sans_SC_Medium;
      color: #333333;
      line-height: 40px;
    }
    .choose-speaker-title{
      margin-top: 42px;
      margin-bottom: 12px;
    }
    .choose-speaker-info{
      font-size: 24px;
      font-family: HarmonyOS_Sans_SC;
      color: #666666;
    }

    .speaker-list {
      flex: 1;
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      justify-content: space-around;
      justify-items: center;
      align-content: start;
      row-gap: 48px;
      padding: 24px 0;
      margin-top: 18px;
      overflow-y: auto;

      .list-item {
        position: relative;
        display: grid;
        justify-items: center;
        font-size: 28px;
        color: #666;
        
        .no-choose{
          position: absolute;
          width: 48px;
          height: 48px;
          right: -25px;
          top: -14px;
          z-index: 2023;
          img{
            width: 36px;
            height: 36px;
            margin-left: 4px;
            margin-top: 7px;
          }
        }
        &.active {
          .active-icon {
            display: block;
          }

          .img-box {
            border-color: #3583fb;
            background-color: #fff;
          }
        }

        .active-icon {
          position: absolute;
          // top: -4px;
          // right: -6px;
          display: none;
          color: #fff;
          z-index: 2022;

          img {
            width: 36px;
          }
        }

        .img-box {
          width: 100px;
          height: 100px;
          margin-bottom: 8px;
          border-radius: 50%;
          border: 4px solid transparent;
          background-size: cover;
          background-position: 50% 50%;
          background-repeat: no-repeat;
        }

        span {
          display: block;
          width: 120px;
          word-break: keep-all;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: center;
        }
      }
    }

    .speaker-list-bottom {
      padding-bottom: 46px;
    }

    .tips-text {
      height: 80px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 60px;
      padding: 0 32px;
      font-size: 28px;
      color: #333;
      background-color: #ccdffe;

      &.error {
        background-color: #fec8c8;

        span {
          display: block;
          width: 100%;
          color: #ea4036;
          text-align: center;
        }
      }

      span {
        display: block;
        width: 100%;
        text-align: center;
      }

      ul {
        display: flex;
      }

      .clear-btn {
        line-height: 40px;
        font-size: 28px;
        color: #3583fb;
        cursor: pointer;
      }
    }

    button {
      display: block;
      width: 80%;
      height: 80px;
      margin: 34px auto 0;
      border-radius: 40px;
      font-size: 32px;
      color: #ffffff;
      border: none;
      background-image: linear-gradient(90deg, #23c0ff 0%, #2384ff 100%);
    }
  }
}

.search-input-wrapper {
  margin: 0 auto;
  width: 650px;
}
</style>
<style lang="less">
.voice-container2{
  display: initial !important;
  position: fixed;
  top: 0;
  z-index: 2024;
  .buy-bg{
    display: none;
  }
}
</style>